<template>
  <div class="wrapper">
    <div class="">
      <slide-travail @oga="retourPays"></slide-travail>
    </div>
    <france v-if="pays === 'france'"></france>
    <canada v-if="pays === 'canada'"></canada>
    <usa v-if="pays === 'usa'"></usa>
    <turkie v-if="pays === 'turquie'"></turkie>
    <Chypre v-if="pays === 'chypre'"></Chypre>
    <japon v-if="pays === 'japon'"></japon>
    <chine v-if="pays === 'chine'"></chine>
    <benin v-if="pays === 'bresil'"></benin>
  </div>
</template>

<script>
import slideTravail from "@/views/myComponents/paysDispo/slideTravail";
import france from "@/views/myComponents/paysDispo/france";
import Canada from "@/views/myComponents/paysDispo/canada";
import Usa from "@/views/myComponents/paysDispo/usa";
import Turkie from "@/views/myComponents/paysDispo/turkie";
import Chypre from "@/views/myComponents/paysDispo/chypre";
import Japon from "@/views/myComponents/paysDispo/japon";
import Chine from "@/views/myComponents/paysDispo/chine";
import Benin from "@/views/myComponents/paysDispo/benin";
export default {
  bodyClass: "etude",
  components: {
    Benin,
    Chine,
    Japon,
    Chypre,
    Turkie,
    Usa,
    Canada,
    slideTravail,
    france
  },
  props: {
    pays2: {
      type: String,
      default: require("@/assets/img/france.jpeg")
    },
    pays3: {
      type: String,
      default: require("@/assets/img/usa.jpeg")
    },
    pays4: {
      type: String,
      default: require("@/assets/img/turkie.jpeg")
    }
  },
  data() {
    return {
      pays: "france"
    };
  },

  computed: {
    headerStyle() {
      return {
        backgroundImage: `url(${this.header})`
      };
    }
  },
  created() {
    this.pays = this.$route.query.pays;
  },
  methods: {
    retourPays(answer) {
      this.pays = answer;
    }
  }
};
</script>

<style lang="scss" scoped>
.md-card-actions.text-center {
  display: flex;
  justify-content: center !important;
}
.contact-form {
  margin-top: 30px;
}

.md-has-textarea + .md-layout {
  margin-top: 15px;
}
.hooper {
  height: auto;
}
</style>
